"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

/** Flips between light and dark; "system" resolves to whichever is showing. */
export function useThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const dark = resolvedTheme === "dark";
  return {
    dark,
    toggle: () => setTheme(dark ? "light" : "dark"),
    Icon: dark ? Sun : Moon,
    label: dark ? "Светлая тема" : "Тёмная тема",
  };
}
